import { ScheduledEvent } from './scheduled-event.model';
import { Folder } from '../site-content/folder.model';

import { ScheduledEventObjectType, ScheduledAction } from './scheduled-event.enums';
import { scheduled } from 'rxjs';

// Note:  we are not yet using this model class.
export class ScheduledFolderEvent extends ScheduledEvent {
    // Constructor.
    public constructor(scheduledAction: ScheduledAction) {
        super();

        //this.action = scheduledAction;
    }

    // Properties.
    public folderId: number;

    public folder: Folder;

    // Abstract method(s).
    public objectType(): ScheduledEventObjectType {
        return ScheduledEventObjectType.Folder;
    }
}
